const cardsModal = (): void => {
  const classes = {
    cardsModalOpen: 'cards-modal--modal-open',
  };

  const selectors = {
    cardsModal: '[data-cards-modal]',
    card: '[data-card]',
    cardID: 'data-card',
    cardImage: '[data-card-image]',
    cardTitle: '[data-card-title]',
    cardSubtitle: '[data-card-subtitle]',
    cardSocialLink: '[data-card-social-link]',
    cardContent: '[data-card-content]',
    cardModalToggle: '[data-cards-modal-toggle]',
    cardModalOverlay: '[data-cards-modal-overlay]',
    modal: '[data-cards-modal-modal]',
    modalID: 'data-cards-modal-modal',
    modalImage: '[data-modal-image]',
    modalTitle: '[data-modal-title]',
    modalSubtitle: '[data-modal-subtitle]',
    modalContent: '[data-modal-content]',
    modalSocialLink: '[data-modal-social-link]',
    modalPrev: '[data-modal-prev]',
    modalNext: '[data-modal-next]',
    modalClose: '[data-modal-close]',
  };

  const cardsModalSections = document.querySelectorAll(selectors.cardsModal);

  cardsModalSections.forEach((section) => {
    const cards = section.querySelectorAll(selectors.card);
    const modal = section.querySelector(selectors.modal);

    if (modal) {
      const modalOverlay = modal.querySelector(selectors.cardModalOverlay);
      const modalClose = modal.querySelector(selectors.modalClose);
      const modalPrev = modal.querySelectorAll(selectors.modalPrev);
      const modalNext = modal.querySelectorAll(selectors.modalNext);

      const modalImage = modal.querySelector(selectors.modalImage);
      const modalTitle = modal.querySelector(selectors.modalTitle);
      const modalSubtitle = modal.querySelector(selectors.modalSubtitle);
      const modalSocialLink = modal.querySelector(selectors.modalSocialLink);
      const modalContent = modal.querySelector(selectors.modalContent);

      const resetModal = (): void => {
        if (modalImage) {
          modalImage.innerHTML = '';
        }
        if (modalTitle) {
          modalTitle.innerHTML = '';
        }
        if (modalSubtitle) {
          modalSubtitle.innerHTML = '';
        }
        if (modalSocialLink) {
          modalSocialLink.innerHTML = '';
        }
        if (modalContent) {
          modalContent.innerHTML = '';
        }
      };

      if (modalOverlay) {
        modalOverlay.addEventListener('click', () => {
          section.classList.remove(classes.cardsModalOpen);

          setTimeout(() => {
            resetModal();
          }, 300);
        });
      }

      if (modalClose) {
        modalClose.addEventListener('click', () => {
          section.classList.remove(classes.cardsModalOpen);

          setTimeout(() => {
            resetModal();
          }, 300);
        });
      }

      if (modalPrev) {
        modalPrev.forEach((prev) => {
          prev.addEventListener('click', () => {
            const modalID = modal.getAttribute(selectors.modalID);
            let prevID: any = parseInt(modalID) - 1;
            prevID = prevID.toString();

            const prevIDToggle = section.querySelector<HTMLButtonElement>(
              '[data-cards-modal-toggle="' + prevID + '"]'
            );

            if (prevIDToggle) {
              resetModal();
              prevIDToggle.click();
            }
          });
        });
      }

      if (modalNext) {
        modalNext.forEach((next) => {
          next.addEventListener('click', () => {
            const modalID = modal.getAttribute(selectors.modalID);
            let nextID: any = parseInt(modalID) + 1;
            nextID = nextID.toString();

            const nextIDToggle = section.querySelector<HTMLButtonElement>(
              '[data-cards-modal-toggle="' + nextID + '"]'
            );

            if (nextIDToggle) {
              resetModal();
              nextIDToggle.click();
            }
          });
        });
      }
    }

    cards.forEach((card) => {
      const cardID = card.getAttribute(selectors.cardID);
      const modalToggles = card.querySelectorAll(selectors.cardModalToggle);

      modalToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          if (modal) {
            modal.setAttribute(selectors.modalID, cardID);

            const cardImage = card.querySelector(selectors.cardImage);
            const modalImage = modal.querySelector(selectors.modalImage);
            if (modalImage && cardImage) {
              modalImage.innerHTML = cardImage.innerHTML;
            }

            const cardTitle = card.querySelector(selectors.cardTitle);
            const modalTitle = modal.querySelector(selectors.modalTitle);
            if (modalTitle && cardTitle) {
              modalTitle.innerHTML = cardTitle.innerHTML;
            }

            const cardSubtitle = card.querySelector(selectors.cardSubtitle);
            const modalSubtitle = modal.querySelector(selectors.modalSubtitle);
            if (modalSubtitle && cardSubtitle) {
              modalSubtitle.innerHTML = cardSubtitle.innerHTML;
            }

            const cardSocialLink = card.querySelector(selectors.cardSocialLink);
            const modalSocialLink = modal.querySelector(
              selectors.modalSocialLink
            );
            if (cardSocialLink && modalSocialLink) {
              modalSocialLink.innerHTML = cardSocialLink.innerHTML;
            }

            const cardContent = card.querySelector(selectors.cardContent);
            const modalContent = modal.querySelector(selectors.modalContent);
            if (modalContent && cardContent) {
              modalContent.innerHTML = cardContent.innerHTML;
            }
          }

          section.classList.add(classes.cardsModalOpen);
        });
      });
    });
  });
};

export default cardsModal;
